<template>
  <div class="footer">
    <div class="footer-msg">
      <div class="navigation">
        <div class="navtion_a">
          <a href="javascript:void(0)" style="color:#ff8a00"
            >适龄提示：适合7岁以上使用</a
          >
          <a
            href="https://www.canpoint.net/index/index/microteacher"
            target="_blank"
            >教师信息公示</a
          >
          <a href="javascript:void(0)"
            ><label for="modal_1" style="cursor:pointer"
              >备案内容承偌书</label
            ></a
          >
          <el-popover placement="right" width="100px" v-model="visible">
            <div class="column code-box">
              <img src="../../assets/images/manfen_code.png" class="code-img" />
            </div>
            <a href="javascript:;" style="border-right:0;" slot="reference"
              >更多服务</a
            >
          </el-popover>
        </div>
      </div>
      <div class="copyright">
        <div class="champoin">
          <p>
            Copyright © 2010-2021北京全品文教科技股份有限公司canpoint.net. All
            rights reserved.
            京ICP备15050178号-2&nbsp;&nbsp;京ICP证161058&nbsp;&nbsp;京网文[2017]
            2347-233号
          </p>
        </div>
      </div>
    </div>
    <!-- 机构承诺start -->
    <div class="organization_modal">
      <input type="checkbox" name="" id="modal_1" />
      <label for="modal_1" class="overlay"></label>
      <div class="organization">
        <img
          src="https://wk.canpoint.net/Template/style1/style_img/123456.png"
          class="images"
        />
      </div>
    </div>
    <!-- end机构承诺-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style scoped>
/*底部信息*/
.footer {
  clear: both;
  /* height: 340px; */
  background: #2f2f2f;
  padding: 0;
  font: 12px "微软雅黑";
}

.footer .navigation {
  height: 25px;
  width: 1195px;
  text-align: center;
  padding-top: 20px;
  margin: 0 auto;
}
.footer .navigation a {
  border-right: 1px solid #595959;
  padding: 0 15px;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  color: #7f7f7f;
}
.footer .navigation a:hover {
  color: rgb(255, 138, 0);
}
.footer .copyright .champoin {
  width: 1195px;
  margin: 0 auto;
}
.footer .copyright .champoin p {
  font-size: 12px;
  height: 33px;
  margin: 0 auto;
  color: #595959;
  line-height: 33px;
  text-align: center;
}

.code-img {
  width: 125px;
  height: 125px;
}
/* 机构承诺 */
.organization_modal > input {
  display: none;
}
.organization_modal > input ~ * {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
}
.organization_modal .overlay {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  margin: 0;
  border-radius: 0;
  background: rgba(17, 17, 17, 0.6);
  transition: all 0.3s;
  z-index: 100000;
}
.organization_modal .overlay ~ * {
  border: 0;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) scale(0.2, 0.2);
  z-index: 1000000;
  transition: all 0.3s ease;
}
.organization {
  min-width: 1084px;
  padding: 10px;
  text-align: left;
}
/* .organization .images{width: 620px; height:450px;} */
.organization p {
  margin: 5px 10px;
}
.organization_modal > input:checked ~ * {
  display: block;
  opacity: 1;
  max-height: 10000px;
}
.organization_modal > input:checked ~ .overlay ~ * {
  max-height: 90%;
  overflow: auto;
  -webkit-transform: translateX(-50%) translateY(-50%) scale(1, 1);
  transform: translateX(-50%) translateY(-50%) scale(1, 1);
}
.footer .footer-msg {
  background: #262626;
  height: 100px;
}
</style>
